import { defineComponent as _defineComponent } from 'vue'
import { computed, useAsync, useRoute, useStore, watch } from "@nuxtjs/composition-api";

import {
  useAmplitude,
  useBranchService,
  useLike,
  useLtk,
  useProduct,
  useProductImageProps,
  useProductLinkProps,
} from "@/composables";
import { useCreatorShop } from "@/store/creator-shop";
import { getProductDetailsStore } from "@/store/product-details";
import { getProductsStore } from "@/store/products";
import { Actions } from "@/utils/snowplow/enums";
import { createProductImpression } from "@/utils/snowplow/factory";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkPostProduct',
  props: {
  productId: { type: String, required: true },
  referringComponent: { type: String, required: true },
},
  setup(__props) {

const props = __props;



const amplitude = useAmplitude();
const route = useRoute();
const store = useStore();
const productsStore = getProductsStore(store);
const productDetailsStore = getProductDetailsStore(store);
const branch = useBranchService();

const fetch = async () => {
  // Fetch ltk product if it has not yet been loaded
  await productsStore.fetchProductById(props.productId);
  const productDetailsId = productsStore.products[props.productId]?.productDetailsId;
  if (productDetailsId) {
    await productDetailsStore.fetchProductDetailById(productDetailsId);
  }
  return true;
};

const { product, productDetailsId, ltkId, isRetailerProduct, advertiserName } = useProduct(props.productId);

const productImageProps = useProductImageProps({ productId: props.productId, width: "80", height: "80" });
const productLinkProps = useProductLinkProps(props.productId);
const { ltk } = useLtk(ltkId);
const { like } = useLike(ltkId);

const productImpressionPayload = computed(() =>
  createProductImpression(Actions.View, {
    product_id: props.productId,
    promotion_id: ltkId.value,
    creator_id: ltk.value?.profileId ?? "",
  }),
);

const onProductClick = () => {
  if (!product.value) {
    return;
  }

  useCreatorShop().setReferringShopTab();

  amplitude?.sendExitEvent("/product-browser", {
    "ltk-id": ltkId.value,
    "ltk-product-id": props.productId,
    "product-id": productDetailsId.value,
    matching: product.value.matching,
    "product-count": ltk.value?.productIds.length,
    index: ltk.value?.productIds.indexOf(props.productId),
    "advertiser-name": advertiserName.value,
    ltkLiked: !!like.value,
    url: productLinkProps.value.href ?? productLinkProps.value.to,
    "branch-journey-creative-name": branch.lastDisplayedBanner,
    "cookie-banner-creative-name": branch.lastDisplayedCookieBanner || "none",
    "referring-component": amplitude?.getReferringComponentByPage(route.value.name ?? "", "product feed"),
    ...(isRetailerProduct.value && { "ltk-direct-platform": "shopify" }),
  });
};

const onRetailerProductClick = (event: MouseEvent, navigate: (event: MouseEvent) => void) => {
  onProductClick();
  navigate(event);
};

useAsync(fetch, `ltk-product:${props.productId}`);

watch(() => props.productId, fetch, { immediate: false });

return { __sfc: true,props, amplitude, route, store, productsStore, productDetailsStore, branch, fetch, product, productDetailsId, ltkId, isRetailerProduct, advertiserName, productImageProps, productLinkProps, ltk, like, productImpressionPayload, onProductClick, onRetailerProductClick }
}

})